import {
  generateAlgoliaFilters,
  nonAlgoliaFilters,
} from './filtersToQueryString';

export default function buildAlgoliaRequests(
  index,
  search,
  filters,
  privateGroupIds,
  courseVisibility,
  nowTimestamp
) {
  const filtersArray = Object.entries(filters);

  // checked facet filters don't change the count result for other items of the same facet
  // count is evaluated according to **other-facet** filters only
  return filtersArray
    .filter(
      ([filterName, filterValue]) =>
        filterName !== 'country.id' && !nonAlgoliaFilters.includes(filterName)
    )
    .map(([filterName, filterValues]) => {
      const otherFilters = {};
      filtersArray.map(([otherFilterName, otherFilterValues]) => {
        if (filterName !== otherFilterName) {
          otherFilters[otherFilterName] = otherFilterValues;
        }
      });

      return {
        name: filterName,
        request: {
          indexName: index,
          params:
            'query=' +
            search +
            '&facets=' +
            filterName +
            '&filters=' +
            generateAlgoliaFilters(
              otherFilters,
              privateGroupIds,
              courseVisibility,
              nowTimestamp
            ) +
            '&attributesToRetrieve=id' +
            '&hitsPerPage=1',
        },
      };
    });
}
